{#if isVisible}
  <div transition:fly="{{y: 200, duration: 250}}" class="ne-editor-modal">
    <div class="ne-container">
      <slot></slot>
    </div>
  </div>
{/if}

<style>
  .ne-editor-modal {
    box-sizing: border-box;
  }

  .ne-editor-modal :global(*),
  .ne-editor-modal :global(*):before,
  .ne-editor-modal :global(*):after {
    box-sizing: inherit;
  }

  .ne-editor-modal {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 1.5em;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  .ne-container {
    height: 100%;
    width: 100%;
    position: relative;
  }
</style>

<script>
  import { fly } from 'svelte-transitions';

  export let isVisible;
</script>
